import React from 'react';

import { Link } from 'react-router-dom';

import { NavItemProps } from './types';
import usePricingNavigationStyles from './useStyles';

export default function NavItem({ title, selected, url }: Readonly<NavItemProps>): React.ReactElement {
  const { ListItem } = usePricingNavigationStyles();
  return (
    <li className={`${ListItem} ${selected}`}>
      <Link to={url}>
        <strong>{title}</strong>
      </Link>
    </li>
  );
}
